import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import Header from '../../common/header'
import Footer from '../../common/footer'
import SvgIcon from '../../common/svg-icon/svg-icon'
import { Button, Breadcrumb, Card, CardContent, CardDescription, CardMeta, CardHeader } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import ReactPlayer from 'react-player'
import { number_formatter, replaceSpaceInName } from '../../../common/helperMethods';

import axios from 'axios';
import { BASE_URL } from '../../../config/config';
import { NewInviteUser } from '../../common/newInviteUser';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import './index.scss'

import Lithiumion from '../../../assets/images/new-images/Lithiumion.png';
import Solar from '../../../assets/images/new-images/Solar.png';
import OpticalFiber from '../../../assets/images/new-images/OpticalFiber.png';
import GreenHydrogen from '../../../assets/images/new-images/GreenHydrogen.png';
import CarbonFiber from '../../../assets/images/new-images/CarbonFiber.png';
import UVECuring from '../../../assets/images/new-images/UVECuring.jpg';
import Semiconductor from '../../../assets/images/new-images/Semiconductor.jpg';
import AdditiveManufacturing from '../../../assets/images/new-images/AdditiveManufacturing.jpg';
import default_image from '../../../assets/images/add-event-default.png'
import SEO from '../../../components/seo/SEO';
import MediaQuery from 'react-responsive';
const EcosystemView = () => {
  const history = useHistory();
  const [technology1slideData, setTechnology1slideData] = useState([]);
  const [technology2slideData, setTechnology2slideData] = useState([]);
  const [clientsSlideData, setclientsSlideData] = useState([]);
  const [CustomerSaysSlidesData, setCustomerSaysSlidesData] = useState([]);
  const [IndustriesData, setIndustriesData] = useState([]);

  const sections = [
    { key: 'Home', content: 'Home', link: true, href: '/' },
    { key: 'ecosystem', content: 'Ecosystem', link: false },
  ]

  useEffect(() => {
    axios.get(`${BASE_URL}/api/v2/testimonials/list`, {
      "from": 0,
      "size": 10
    }).then((response) => {
      const { data } = response.data
      if (data.length < 4) {
        data.push(data[1]);
      }
      setCustomerSaysSlidesData(data)

    }).finally(() => {
      //  setLoading(false)
    })



    axios.get(`${BASE_URL}/api/v2/industries/get`, {
      "from": 0,
      "size": 10
    }).then((response) => {
      const { data } = response.data
      if (data.length > 0) {
        for (let index in data) {
          data[index]['image'] = '';
          data[index]['link'] = '';

          if (data[index]['product']['id'] == "SkW9l-VnJRsG") {
            data[index]['image'] = OpticalFiber;
            data[index]['link'] = 'ecosystem/optical-fiber';
          }

          if (data[index]['product']['id'] == "HJpXxbE2yRjG") {
            data[index]['image'] = UVECuring;
            data[index]['link'] = 'ecosystem/uv-eb-curing';
          }

          if (data[index]['product']['id'] == "S1mF5ohWK") {
            data[index]['image'] = GreenHydrogen;
            data[index]['link'] = 'ecosystem/green-hydrogen';
          }

          if (data[index]['product']['id'] == "HkqK_ZLfZvaDX") {
            data[index]['image'] = Semiconductor;
            data[index]['link'] = 'ecosystem/semiconductors';
          }

          if (data[index]['product']['id'] == "S1aD-N21Ciz") {
            data[index]['image'] = CarbonFiber;
            data[index]['link'] = 'ecosystem/carbon-fiber';
          }

          if (data[index]['product']['id'] == "rkxIVP6OrI") {
            data[index]['image'] = AdditiveManufacturing;
            data[index]['link'] = 'ecosystem/additive-manufacturing';
          }

          if (data[index]['product']['id'] == "ryh4YXLfWP6DX") {
            data[index]['image'] = Solar;
            // data[index]['name'] = 'Solar';

            data[index]['link'] = 'ecosystem/solar';
          }

          if (data[index]['product']['id'] == "SyG_WFgFX") {
            data[index]['image'] = Lithiumion;
            data[index]['link'] = 'ecosystem/lithium-ion';
          }

        }
      }

      console.log('data ', data)
      setIndustriesData(data)
      localStorage.setItem('industry_data', JSON.stringify(data));
    }).finally(() => {
      //  setLoading(false)
    })


    axios.post(`${BASE_URL}/api/v1/product/trending/list`, {
      "from": 0,
      "size": 16
    }).then((response) => {
      const { data } = response.data

      let part1 = 8
      let part2 = 8
      let tech1 = [];
      let tech2 = [];
      if (data.totalRecords > 8) {
        part2 = data.totalRecords - 8;
      }

      for (let i = 0; i < data.totalRecords; i++) {
        if (i < part1) {
          tech1.push(data.rows[i]);
        } else {
          tech2.push(data.rows[i]);
        }
      }
      setTechnology1slideData(tech1)
      setTechnology2slideData(tech2)

    }).finally(() => {
      //  setLoading(false)
    })

    axios.post(`${BASE_URL}/api/v2/company/partner/list`, {
      "from": 0,
      "size": 10
    }).then((response) => {
      const { data } = response.data
      setclientsSlideData(data.rows)

    }).finally(() => {
      //  setLoading(false)
    })

  }, [])

  const gotoCompany = (item) => {
    if (item.name != undefined && item.id != undefined) {

      history.push(`/company/${replaceSpaceInName(item.name)}/${item.id}`);
    }
  }


  const gotoProduct = (item) => {
    if (item.name != undefined && item.id != undefined) {
      history.push(`/product/${replaceSpaceInName(item.name)}/${item.id}`);
    }
  }

  const gotoRequestQuote = (item) => {
    if (item.name != undefined && item.id != undefined) {
      history.push(`/request-quote/product/${item.id}`);
    }
  }

  const render_image = (item) => {
    const { original_images } = item || {};
    if (original_images && original_images.length > 0) {
      return (
        <Link to={`/product/${replaceSpaceInName(item.name)}/${item.id}`}><img src={original_images[0]['value']} alt='' /></Link>

      )
    } else {
      return (
        <Link to={`/product/${replaceSpaceInName(item.name)}/${item.id}`}><img src={default_image} alt='' /></Link>
      )
    }
  }

  const render_partner_image = (item) => {
    if (item.logo) {
      return (
        <Button onClick={() => gotoCompany(item)}> <img src={item.logo} alt='' /></Button>
      )
    } else {
      return (
        <Button onClick={() => gotoCompany(item)}><img src={default_image} alt='' /></Button>
      )

    }
  }

  const render_products = (listdata, heading) => {
    return (
      <section className='technologies-section'>
        <div className='mappes-container'>
          {heading == 1 && <h1 className='main-heading text-left'>Deep Dive Into <span>Emerging Technologies</span> </h1>}
          <div className='technologies-row'>
            {listdata.map(item => (
              <div key={item.id} className='technologies-card'>
                <div className='card-upper'>
                  {render_image(item)}
                </div>
                <div className='card-bottom'>
                  <div className='event-name'>
                    <Link to={`/product/${replaceSpaceInName(item.name)}/${item.id}`} >{item.name}</Link>
                    <ul>
                      {/* <li>{item.followers} <SvgIcon name='staricon' viewbox="0 0 14 13" /></li> */}
                      {item.view_count != undefined && item.view_count != 0 && <li>{number_formatter(item.view_count)} <SvgIcon name='eye-icon' viewbox="0 0 10 7" /></li>}
                    </ul>
                  </div>
                  <div className='info-list'>
                    <div className='list-item'>{number_formatter(item.supplier_count)}&nbsp; Suppliers&nbsp; |&nbsp; {number_formatter(item.application_count)}&nbsp; Applications&nbsp; |&nbsp; {number_formatter(item.raw_material_count)}&nbsp; Materials</div>
                  </div>
                </div>
                <div className='card-action'>
                  <Button onClick={() => gotoProduct(item)}>Explore </Button>
                  <Button onClick={() => gotoRequestQuote(item)}>Request Quote</Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    )
  }

  const gotoProductPage = (link) => {
    if (link != '') {
      console.log('link ', link)
      history.push(`${link}`);
    }
  }

  return (
    <>
      <SEO key="ecosystem-index-seo"
        robots="index, follow"
        canonicalUrl="/ecosystem"
        alternateLink="/ecosystem"
        pageType={'ecosystem'}
        pageContent={{ pageName: 'Discover Suppliers & Technologies in the Mappes Ecosystem', pageDescription: 'Explore the Mappes ecosystem to find suppliers, technologies, and applications across multiple manufacturing value chains.' }}
      />
      <Header />
      <div className='ecosystempage-view'>
        <section className='breadcrumb-section'>
          <div className='mappes-container'>
            <Breadcrumb icon={<SvgIcon name='chevron-right' viewbox="0 0 8 14" />} sections={sections} />
          </div>
        </section>
        <section className='banner-section'>
          <div className='mappes-container'>
            <div className='banner-card'>
              <div className='video-banner-card' style={{}}>
                <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                  <ReactPlayer
                    url='https://www.youtube.com/watch?v=YehQsr4hi7Y'
                    playing={true}
                    loop={true}
                    fullscreen={false}
                    playIcon={false}
                    width="100%"
                    muted={true}
                    height="100%"
                    controls={false}
                  />
                </div>
              </div>
              <div className='overlay-div'>
                <h2>From Fragmented Information to Ecosystem Intelligence</h2>
                <p>Mapping complete end-to-end value chains and unifying technology, suppliers, customers, contacts, materials, equipment, events, and insights — all in one intelligent platform.</p>
              </div>
              {/*  <div className='overlay-btn'><Button primary>Know More</Button></div> */}
            </div>
          </div>
        </section>
        <section className='exploreindustries-section'>
          <div className='mappes-container'>
            <h1 className='main-heading text-left'>Explore and be a part of <span>Emerging Value Chains</span></h1>
            <div className='exploreindustries-row'>
              {IndustriesData.length > 0 && IndustriesData.map(item => (
                <div key={item.id} className='exploreindustries-col cursor-pointer ' onClick={() => gotoProductPage(item.link)}>

                  {item.image && <img src={item.image} alt='' />}
                  <div className='card-overlay'><h3>{item.name != undefined ? item.name : ''}</h3></div>
                </div>
              ))
              }
            </div>
          </div>
        </section>
        <section className='ourpartner-section'>
          <div className='mappes-container'>
            <h1 className='main-heading text-left'> <span>Network</span> With Innovative Companies</h1>
            <div className='ourpartner-row'>
              <Swiper
                spaceBetween={20}
                modules={[Pagination]}
                loop={true}
                pagination={{ clickable: true }}
                breakpoints={{
                  320: { slidesPerView: 1 },
                  640: { slidesPerView: 2 },
                  1024: { slidesPerView: 3 },
                  1300: { slidesPerView: 4 },
                }}
              >
                {clientsSlideData.map((item) => (
                  <SwiperSlide key={item.id}>
                    <div className="ourpartner-card">
                      <div className="card-upper">{render_partner_image(item)}</div>

                      <div className="card-bottom">
                        <div className="event-name">
                          <Link to={`/company/${replaceSpaceInName(item.name)}/${item.id}`}> {item.name}</Link>
                          <ul>
                            {/* Uncomment to show stars if needed
                            <li>
                              {item.view_count} <SvgIcon name="staricon" viewbox="0 0 14 13" />
                            </li>
                            */}
                            {item.view_count != 0 &&
                              <li>
                                {item.view_count != undefined && number_formatter(item.view_count)} <SvgIcon name='eye-icon' viewbox="0 0 10 7" />
                              </li>
                            }
                          </ul>
                        </div>

                        <div className='info-list'>
                          <div className='list-item'>{number_formatter(item.product_count)} &nbsp; Technologies &nbsp;|&nbsp; {number_formatter(item.mapping)} &nbsp;
                            {/* Applications &nbsp;|&nbsp;  */}
                            {number_formatter(item.employee_count)} &nbsp; People</div>
                        </div>
                      </div>

                      <div className="card-action">
                        <Button onClick={() => gotoCompany(item)}>Explore </Button>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </section>
        {render_products(technology1slideData, 1)}
        <section className='customersays-section'>
          <div className='mappes-container'>
            <div className='customersays-left'>
              <h1 className='main-heading'>Testimonials from <br /><span>Industry Leaders</span></h1>
            </div>
            <div className='customersays-right'>
              <Swiper
                spaceBetween={20}
                modules={[Pagination]}
                pagination={{ clickable: true }}
                loop={true}
                initialSlide={0}
                keyboard={true}
                direction={"horizontal"}
                mousewheel={{
                  releaseOnEdges: true,
                }}
                speed={700}
                breakpoints={{
                  320: { slidesPerView: 1.3 },
                  576: { slidesPerView: 1.3 },
                  768: { slidesPerView: 2 },
                  1024: { slidesPerView: 2.5 },
                }}
              >
                {CustomerSaysSlidesData.length > 0 &&
                  CustomerSaysSlidesData.map((slide) => (
                    <SwiperSlide key={slide.id}>
                      <div className="slide-item">
                        <Card>
                          <CardContent>
                            <SvgIcon className="quoteicon" name="quotes-icon" viewbox="0 0 82 64" />
                            <CardHeader>{slide.user_name}</CardHeader>
                            <CardMeta>
                              <span className="time-col">{slide.designation}</span> |{' '}
                              <span className="company-name">{slide.company}</span>
                            </CardMeta>
                            <CardDescription>{slide.comment}</CardDescription>
                          </CardContent>
                        </Card>
                      </div>
                    </SwiperSlide>
                  ))}
              </Swiper>
            </div>
          </div>
        </section>

        <MediaQuery minWidth={767}>
          {render_products(technology2slideData, 2)}
        </MediaQuery>

        <section className='mappessubcribe-section'>
          <div className='mappes-container'>
            <div className='mappessubcribe-card'>
              <div className='mappessubcribe-row'>
                <h2>Explore <span>end-to-end value chains</span> of emerging industry verticals with <span>Mappes.io</span></h2>

                <NewInviteUser />
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  )
}

export default EcosystemView